/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Which record fields read as links in v2: phone numbers call, emails open
 * the mail app, websites open in a new tab. Decided from the field's label
 * (the field components only know their label) and checked against the
 * value, so a "Phone" field holding "n/a" stays plain text.
 */

const PHONE_LABEL = /\b(phone|mobile|cell|telephone|tel|whatsapp|fax)\b/i;
const EMAIL_LABEL = /\be-?mail\b/i;
const WEBSITE_LABEL = /\b(website|web site|url|homepage|linkedin|link)\b/i;

const looksLikeEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
const looksLikePhone = (v) => /^[+()\d\s.-]+$/.test(v) && v.replace(/\D/g, "").length >= 6;
const looksLikeWebsite = (v) => !/\s/.test(v) && /^(https?:\/\/)?[^\s/]+\.[a-z]{2,}([/?#].*)?$/i.test(v);

/** "phone" | "email" | "website" | null */
export function contactLinkKind(label, value) {
  const v = typeof value === "string" ? value.trim() : "";
  if (!v) return null;
  const l = String(label || "");
  // Fax numbers are not dialled.
  if (PHONE_LABEL.test(l) && !/\bfax\b/i.test(l)) return looksLikePhone(v) ? "phone" : null;
  if (EMAIL_LABEL.test(l)) return looksLikeEmail(v) ? "email" : null;
  if (WEBSITE_LABEL.test(l)) return looksLikeWebsite(v) ? "website" : null;
  return null;
}

/** An address a browser can open: adds https:// when no protocol is given. */
export function websiteHref(value) {
  const v = String(value || "").trim();
  return /^https?:\/\//i.test(v) ? v : `https://${v}`;
}

/** The website as people say it: no protocol, no trailing slash. */
export function websiteLabel(value) {
  return String(value || "").trim().replace(/^https?:\/\//i, "").replace(/\/$/, "");
}

/** A tel: address: digits and a leading +, nothing else. */
export function telHref(value) {
  const v = String(value || "").trim();
  return `tel:${v.startsWith("+") ? "+" : ""}${v.replace(/\D/g, "")}`;
}
